import { render, staticRenderFns } from "./b24.vue?vue&type=template&id=635e6e35&scoped=true"
import script from "./b24.vue?vue&type=script&lang=js"
export * from "./b24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e6e35",
  null
  
)

export default component.exports